import { useState } from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Avatar, Button, Checkbox, IconButton, TableCell, TableRow, useTheme } from '@mui/material'

import { DndBurgerIcon } from 'src/assets/icons'
import { UpdateUnSdgModal } from '../update-un-sdg'
import { useMe, useTableItemsCheck } from 'src/hooks'

import { IUnSdgBaseWithId } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'
import { useStyles } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IUnSdgRowProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IUnSdgBaseWithId
  index: number
  orderingDisabled: boolean
}

const UnSdgRow = ({
  row,
  isItemSelected,
  handleItemCheck,
  index,
  orderingDisabled,
}: IUnSdgRowProps) => {
  const [open, setOpen] = useState(false)
  const { data: user } = useMe()

  const classes = useStyles()
  const theme = useTheme()

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  return (
    <>
      <Draggable draggableId={row.id} index={index}>
        {(provided, snapshot) => (
          <TableRow
            key={row.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{
              backgroundColor: theme.palette.custom.white,
              display: snapshot.isDragging ? 'table' : 'table-row',
              tableLayout: 'fixed',
              ...provided.draggableProps.style,
            }}
          >
            <TableCell width="7%">
              <Checkbox
                checked={isItemSelected(row.id)}
                onChange={handleItemCheck(row.id)}
                sx={{ color: theme.palette.custom.grey2 }}
              />
            </TableCell>
            <TableCell width="7%">
              <Avatar src={row.image_small || row.image} variant="square" alt={row.name} />
            </TableCell>
            <TableCell width="30%">{row.name}</TableCell>
            <TableCell width="17%" align="center">
              {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
            </TableCell>
            <TableCell width="17%" align="center">
              {getTableTimestamp({ date: row.updated_at, timezone: user?.timezone })}
            </TableCell>
            <TableCell width="10%">
              <Button onClick={handleOpen}>
                <HelperWrapper t="update-button-text" />
              </Button>
            </TableCell>
            <TableCell width="7%">
              <IconButton
                disabled={orderingDisabled}
                className={classes.orderIcon}
                {...provided.dragHandleProps}
              >
                <DndBurgerIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        )}
      </Draggable>
      <UpdateUnSdgModal handleClose={handleClose} open={open} initialValues={row} />
    </>
  )
}

export { UnSdgRow }
